// (function () {
//   function updateInventoryStatus(variant) {
//     const inventoryWrap = document.querySelector(".js-product-inventory");
//     if (!inventoryWrap || !variant) return;

//     const container = inventoryWrap.querySelector(
//       ".product-inventory-status__container"
//     );

//     if (!container) return;

//     const qty = variant.inventory_quantity;
//     const continueSelling =
//       variant.inventory_policy === "continue" ||
//       variant.inventory_management === null;

//     // Reset
//     inventoryWrap.classList.remove("is-hidden");
//     container.innerHTML = "";

//     // Hide if continue selling or no inventory tracking
//     if (continueSelling || qty < 1) {
//       inventoryWrap.classList.add("is-hidden");
//       return;
//     }

//     if (qty <= 5) {
//       container.innerHTML = `
//         <span class="inventory-badge inventory-badge--low">
//           Only ${qty} left
//         </span>
//       `;
//       return;
//     }

//     if (qty <= 10) {
//       container.innerHTML = `
//         <span class="inventory-badge inventory-badge--fast">
//           Selling fast
//         </span>
//       `;
//       return;
//     }

//     container.innerHTML = `
//       <span class="inventory-badge inventory-badge--in-stock">
//         In stock
//       </span>
//     `;
//   }

//   // Shopify variant change event
//   document.addEventListener("variant:change", function (event) {
//     if (!event.detail || !event.detail.variant) return;
//     updateInventoryStatus(event.detail.variant);
//   });

//   // Initial load fallback (important)
//   document.addEventListener("DOMContentLoaded", function () {
//     if (window?.Shopify?.analytics?.meta?.selectedVariantId) return;
//   });
// })();


// (function () {
//   function getSelectedVariantId() {
//     const variantScript = document.querySelector('[data-selected-variant]');
//     if (!variantScript) return null;

//     try {
//       return JSON.parse(variantScript.textContent).id;
//     } catch {
//       return null;
//     }
//   }

//   function updateInventory() {
//     const inventoryData = document.getElementById("ProductInventoryData");
//     if (!inventoryData) return;

//     const inventoryMap = JSON.parse(inventoryData.textContent);
//     const variantId = getSelectedVariantId();
//     if (!variantId || !inventoryMap[variantId]) return;

//     const { qty, policy } = inventoryMap[variantId];

//     const wrapper = document.querySelector(".js-product-inventory");
//     if (!wrapper) return;

//     const container = wrapper.querySelector(
//       ".product-inventory-status__container"
//     );

//     wrapper.classList.remove("is-hidden");
//     container.innerHTML = "";

//     if (policy === "continue" || qty < 1) {
//       wrapper.classList.add("is-hidden");
//       return;
//     }

//     if (qty <= 5) {
//       container.innerHTML = `<span class="inventory-badge inventory-badge--low">Only ${qty} left</span>`;
//     } else if (qty <= 10) {
//       container.innerHTML = `<span class="inventory-badge inventory-badge--fast">Selling fast</span>`;
//     } else {
//       container.innerHTML = `<span class="inventory-badge inventory-badge--in-stock">In stock</span>`;
//     }
//   }

//   function watchVariantChanges() {
//     document.addEventListener("change", (e) => {
//       if (e.target.matches('input[type="radio"][name^="option"]')) {
//         setTimeout(updateInventory, 10);
//       }
//     });
//   }

//   document.addEventListener("DOMContentLoaded", () => {
//     updateInventory();
//     watchVariantChanges();
//   });
// })();











(function () {
  function getSelectedVariantId() {
    const variantScript = document.querySelector('[data-selected-variant]');
    if (!variantScript) return null;

    try {
      return JSON.parse(variantScript.textContent).id;
    } catch {
      return null;
    }
  }

  function updateInventory() {
    const inventoryData = document.getElementById("ProductInventoryData");
    if (!inventoryData) return;

    const inventoryMap = JSON.parse(inventoryData.textContent);
    const variantId = getSelectedVariantId();
    if (!variantId || !inventoryMap[variantId]) return;

    const { qty, policy } = inventoryMap[variantId];

    const wrapper = document.querySelector(".js-product-inventory");
    if (!wrapper) return;

    const container = wrapper.querySelector(
      ".product-inventory-status__container"
    );

    container.innerHTML = "";
    wrapper.classList.remove("is-hidden");

    // OUT OF STOCK
    if (qty <= 0) {
      container.innerHTML = `
        <span class="inventory-badge inventory-badge--out">
          Out of stock
        </span>`;
      return;
    }

    // SELLING FAST
    if (qty <= 10) {
      container.innerHTML = `
        <span class="inventory-badge inventory-badge--low">
          Only ${qty} left
        </span>`;
      return;
    }

    // LOW STOCK
    // if (qty <= 10) {
    //   container.innerHTML = `
    //     <span class="inventory-badge inventory-badge--fast">
    //       Selling fast
    //     </span>`;
    //   return;
    // }

    // IN STOCK
    container.innerHTML = `
      <span class="inventory-badge inventory-badge--in-stock">
        In stock
      </span>`;
  }

  function watchVariantChanges() {
    document.addEventListener("change", (e) => {
      if (e.target.matches('input[type="radio"][name^="option"]')) {
        setTimeout(updateInventory, 10);
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    updateInventory();
    watchVariantChanges();
  });
})();
